import React, { useEffect } from 'react';
import SubmitButton from './SubmitButton';
import { useLocation } from 'react-router-dom';
import {
  CheckCircleIcon,
  HandThumbUpIcon,
  MapPinIcon,
  CurrencyPoundIcon,
  ArrowRightStartOnRectangleIcon,
} from '@heroicons/react/24/solid';
import { useFlow } from '../utilities/useFlow';
import { axiosKK } from '../services/networkRequest';

export default function Header(): JSX.Element {
  const { pathname } = useLocation();
  const flow = useFlow();
  const userStr = localStorage.getItem('user');
  const isLoggedIn = !!userStr;

  const handleLogout = () => {
    localStorage.removeItem('user');
    delete axiosKK.defaults.headers.common['Authorization'];
    window.location.assign('/');
  };

  useEffect(() => {
    window.fbq('track', 'PageView');
  }, [pathname]);

  return (
    <header className="App-header">
      <nav className="navbar">
        <div className="container">
          {flow === 'Keepr' ? (
            <a href="/" className="navbar-brand keepr-text-logo">
              <img
                src="/img/svg/keepr.svg"
                alt="Keepr Logo"
                className="keepr-svg-logo"
              />
            </a>
          ) : flow === 'St Annes' ? (
            <a href="/" className="navbar-brand stannes-logo">
              <img
                src="/img/svg/st-annes-fullcolour-WHITE-RGB.svg"
                alt="St Anne's College, Oxford"
                className="stannes-svg-logo"
              />
            </a>
          ) : (
            <a href="/" className="navbar-brand">
              <img
                src="/img/Kit Keeper Logo - White.png"
                width="185"
                alt="LOGO"
              />
            </a>
          )}
          <section className="nav-exclude-img">
            <ul id="primary" className="navbar-nav items">
              <li className="menu-item">
                <a
                  href={
                    flow === 'Keepr'
                      ? 'https://keepr.co'
                      : flow === 'St Annes'
                      ? 'https://www.st-annes.ox.ac.uk'
                      : '../storage/boxes'
                  }
                  target="_blank"
                  rel="noreferrer"
                  className={pathname?.includes('storage') ? 'active' : ''}
                >
                  <h5>Storage</h5>
                </a>
              </li>
              {flow !== 'Keepr' && flow !== 'St Annes' && (
                <li className="menu-item">
                  <a
                    href="../shipping/boxes"
                    target="_blank"
                    rel="noreferrer"
                    className={pathname?.includes('suitcase') ? 'active' : ''}
                  >
                    <h5>Shipping</h5>
                  </a>
                </li>
              )}
              {/*<li className="menu-item"><a href="https://www.kitkeeper.co.uk/faqs/">FAQs</a></li>*/}
              {flow !== 'Keepr' && flow !== 'St Annes' && (
                <li className="menu-item">
                  <a
                    href="https://www.kitkeeper.co.uk/blog/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <h5>News</h5>
                  </a>
                </li>
              )}
              <li className="menu-item">
                <a
                  href={
                    flow === 'Keepr'
                      ? 'https://keepr.co/#faqs'
                      : flow === 'St Annes'
                      ? 'https://www.st-annes.ox.ac.uk/current-students/'
                      : 'https://www.kitkeeper.co.uk/#faqs'
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <h5>Support</h5>
                </a>
              </li>
              <li className="menu-item">
                {isLoggedIn ? (
                  <button
                    type="button"
                    onClick={handleLogout}
                    className="header-login-btn"
                    title="Logout"
                  >
                    <ArrowRightStartOnRectangleIcon className="header-auth-icon" />
                    Logout
                  </button>
                ) : (
                  <a href="../login" className="header-login-btn">
                    <img
                      src="/img/LoginIcon.png"
                      className="header-auth-icon"
                      alt=""
                      style={{ width: 18, height: 18 }}
                    />
                    Login
                  </a>
                )}
              </li>
            </ul>

            {/*
            <div className="pipe-div">|</div>
            */}
            {/*}   COMMENTING OUT THE SOCIAL MEDIA ICONS IN THE  HEADER BAR
            <ul id="primary" className="navbar-nav icons">

              <li className="social-icons">
                <a href="https://www.facebook.com/kitkeeper" target="_blank" rel="noreferrer">
                  <i className="fab fa-facebook-f" />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://www.instagram.com/kit.keeper" target="_blank" rel="noreferrer">
                  <i className="fab fa-instagram" />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://www.linkedin.com/company/kit-keeper" target="_blank" rel="noreferrer">
                  <i className="fab fa-linkedin-in" />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://twitter.com/kit_keeper" target="_blank" rel="noreferrer">
                  <i className="fab fa-twitter" />
                </a>
              </li>

            </ul>
            */}
            {/*<ul className="navbar toggle">*/}
            {/*  <a href="#" className="nav-link pr-sm-4" data-toggle="modal" data-target="#menu">*/}
            {/*    <i className="fas fa-bars" />*/}
            {/*  </a>*/}
            {/*</ul>*/}
            <div className="contact-button">
              <a
                href={
                  flow === 'Keepr'
                    ? 'https://keepr.co/#contact'
                    : flow === 'St Annes'
                    ? 'https://www.st-annes.ox.ac.uk/contact/'
                    : 'https://www.kitkeeper.co.uk/contact'
                }
                target="_blank"
                rel="noreferrer"
              >
                <SubmitButton>
                  {/* <i className="fas fa-phone-alt" /> COMMENT OUT THE PHONE ICON IN CONTACT US BUTTON */}
                  <span>Contact Us</span>
                </SubmitButton>
              </a>
            </div>
          </section>
        </div>

        <div className="containerConvincer">
          <div className="convincerContent">
            <span className="ConvincerBar1">
              <CheckCircleIcon className="convincerIcon" />
              Flexible pricing
            </span>

            <span className="ConvincerBar2">
              <HandThumbUpIcon className="convincerIcon" />
              Free £100 cover
            </span>

            <span className="ConvincerBar3">
              <CurrencyPoundIcon className="convincerIcon currencyPoundIcon" />
              <div className="innovateUkWrapper">Funded by InnovateUK</div>
            </span>

            <span className="ConvincerBar5">
              <MapPinIcon className="convincerIcon" />
              Collect & deliver anywhere in the UK
            </span>
          </div>
        </div>
      </nav>
    </header>
  );
}
